// @ts-nocheck
import { _ } from "~/i18n";

/**
 * Statistiky galerie
 */
export function buildStats(data) {
	const cont = Mapy.Util.node("div", { className: "stats" });
	const photos = Mapy.Util.node("span");

	photos.innerHTML = `<b>${(data.mediaCount || 0).toLocaleString(Userweb.defaultLang)}</b> ${_("gallery.stats.photos", { NUM: data.mediaCount })}`;
	cont.appendChild(photos);

	if ("viewCount" in data) {
		const views = Mapy.Util.node("span");

		views.innerHTML = `<b>${(data.viewCount || 0).toLocaleString(Userweb.defaultLang)}</b> ${_("gallery.stats.views")}`;
		cont.appendChild(views);
	}

	if ("likeSum" in data) {
		const likes = Mapy.Util.node("span");

		likes.innerHTML = `<b>${(data.likeSum || 0).toLocaleString(Userweb.defaultLang)}</b> ${_("gallery.stats.likes")}`;
		cont.appendChild(likes);
	}

	return cont;
}
